import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

const practiceTaskActivity: Record<Discipline, string> = {
  [Discipline.ELA]: 'ELA',
  [Discipline.Math]: 'math',
}

const practiceTaskDiscipline: Record<Discipline, string> = {
  [Discipline.ELA]: 'ELA',
  [Discipline.Math]: 'Math',
}

export const PRACTICE_REDIRECT_PATH: Record<Discipline, string> = {
  [Discipline.Math]: '/math',
  [Discipline.ELA]: '/reading',
}

export const getPracticeTaskDescription = (discipline: Discipline, tutorName: string, kidName: string): string =>
  `${tutorName} picked a short ${practiceTaskActivity[discipline]} activity for ${kidName}`

export const getPracticeTaskCanceledLessonDescription = (discipline: Discipline, kidName: string): string =>
  `A short ${practiceTaskDiscipline[discipline]} activity for ${kidName}`
